import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { BdmAssessmentComponent } from '../bdm-assessment/bdm-assessment.component';
import { NewRepChecklistComponent } from '../new-rep-checklist/new-rep-checklist.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';

@Component({
  selector: 'app-bdmassessment-navigation',
  imports: [
    CommonModule,
    MatTabsModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    BdmAssessmentComponent,
    NewRepChecklistComponent,
    MatIconModule,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent,
  ],
  templateUrl: './bdmassessment-navigation.page.html',
  styleUrl: './bdmassessment-navigation.page.scss'
})
export class BdmassessmentNavigationPage implements OnInit {
  @ViewChild('BdmTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  selectedIndex: number = 0;
  data = history.state;
  readonly = signal(false);
  designation!: string;

  // 2. Define the total number of tabs (update this based on your app)
  totalTabs: number = 3;

  constructor() { }
  ngOnInit(): void {
    this.selectedTabId = "new-repapplication";
    this.readonly.set(this.data.isReadOnly);
    this.designation = this.data.designation;
  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index; // ✅ IMPORTANT FIX

    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }


  protected nextTab(): void {
    if (this.selectedIndex < this.totalTabs - 1) {
      this.selectedIndex++; // ✅ This automatically switches tab
    }
  }
}